import type { IncidentType } from '@/types';

import getActivePeriods from '@/utils/helpers/get-active-periods';
import getEarliestStartPeriod from '@/utils/helpers/get-earliest-start-period';

type SortableIncident = {
  incident: IncidentType;
  earliestStart: number;
};

const hasAnyActivePeriods = ({ incident }: SortableIncident): boolean =>
  incident.activePeriod.length > 0;

const sortByEarliestStart = (a: SortableIncident, b: SortableIncident): number =>
  a.earliestStart - b.earliestStart;

const processIncidentApiData = (data: IncidentType[]): IncidentType[] => {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  const now = new Date();

  return data
    .map((incident) => {
      const periods = getActivePeriods(incident, now);

      return {
        incident: { ...incident, activePeriod: periods },
        earliestStart: getEarliestStartPeriod(periods),
      };
    })
    .filter(hasAnyActivePeriods)
    .sort(sortByEarliestStart)
    .map(({ incident }) => incident);
};

export default processIncidentApiData;
